export const FeatureFlag = {
	CaregiverAppOnboarding: "CaregiverAppOnboarding",
	IvrEvvVerbalConfirmationNameMatchValidation:
		"IvrEvvVerbalConfirmationNameMatchValidation",
	EnableCcwPepstReq: "EnableCcwPepstReq",
	DashboardAuthManagementV2: "DashboardAuthManagementV2",
	ClientVisitRetransmission: "ClientVisitRetransmission",
	PasskeyManagement: "PasskeyManagement",
} as const;

export type FeatureFlagKey = (typeof FeatureFlag)[keyof typeof FeatureFlag];

export type FeatureFlagValues = Record<string, boolean>;
